import { render, staticRenderFns } from "./productList.vue?vue&type=template&id=0d632da0&scoped=true&"
import script from "./productList.vue?vue&type=script&lang=js&"
export * from "./productList.vue?vue&type=script&lang=js&"
import style0 from "./productList.vue?vue&type=style&index=0&id=0d632da0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d632da0",
  null
  
)

export default component.exports